export default "__VITE_ASSET__DwbpJUfc__"